/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'astro/config/route/building.create.list';


export default class extends Base
{
  isRouteVisible ()
  {
    return super.isRouteVisible() && this.isBuildingTypeFound();
  }


  isRouteDisabled ()
  {
    return super.isRouteDisabled();
  }


  isRouteActivated ()
  {
    return super.isRouteActivated();
  }


  isBuildingTypeFound ()
  {
    return this.galaxy.getConstants().getBuilding(this.args.type) != null;
  }


};
